import '@/styles/globals.css';

import { createRouter,RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { AppProviders } from '@/core/providers/app-providers';
import { useAuthStore } from '@/features/auth';

import { routeTree } from './routeTree.gen';

/**
 * Entry point da app.
 *
 * Ordem do bootstrap:
 *   1. Cria router (TanStack) com a árvore gerada do `routeTree.gen.ts`.
 *   2. Roda `auth.bootstrap()` — hidrata tokens + chama /auth/me.
 *      Esse passo DEVE acontecer antes do primeiro render — guards
 *      precisam ter `isAuthenticated` correto.
 *   3. Render do RouterProvider dentro dos providers globais.
 */

const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
  scrollRestoration: true,
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

async function bootstrap() {
  await useAuthStore.getState().bootstrap();

  const rootEl = document.getElementById('root');
  if (!rootEl) throw new Error('Elemento #root não encontrado no index.html');

  createRoot(rootEl).render(
    <StrictMode>
      <AppProviders>
        <RouterProvider router={router} />
      </AppProviders>
    </StrictMode>,
  );
}

void bootstrap();
